import React, { useEffect, useState } from 'react';
import { updatesApi } from '../api/system.api';
import { authApi } from '../../auth/api/auth.api';

// Detect an explicit force-update signal, tolerating unknown field names.
// Fails OPEN: only blocks when the server clearly demands an update.
const isForceUpdate = (res) => {
  const r = res?.result ?? res;
  if (!r || typeof r !== 'object') return false;
  return (
    r.forceUpdate === true ||
    r.isForceUpdate === true ||
    r.updateRequired === true ||
    r.mandatory === true ||
    r.isMandatory === true ||
    String(r.updateType || '').toLowerCase() === 'force'
  );
};

const BlockScreen = () => (
  <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16, padding: 24, textAlign: 'center', fontFamily: "'Inter', sans-serif", background: '#0f172a', color: '#fff' }}>
    <div style={{ fontSize: 56 }}>🚀</div>
    <h1 style={{ margin: 0, fontSize: 24, fontWeight: 800 }}>Update required</h1>
    <p style={{ margin: 0, fontSize: 14, color: '#94a3b8', maxWidth: 380 }}>
      A newer version of CityCraft is available. Please refresh the page to continue.
    </p>
    <button
      onClick={() => window.location.reload()}
      style={{ marginTop: 8, padding: '11px 26px', borderRadius: 10, background: '#082189', color: '#fff', border: 'none', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}
    >
      Refresh
    </button>
  </div>
);

// App-boot gate: runs CheckVersion (blocks only on explicit force-update) and
// pings Login/Status for connectivity. Non-blocking by default.
const AppBootGate = ({ children }) => {
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    let cancelled = false;
    // Force-update check — fail open.
    updatesApi.checkVersion()
      .then((res) => { if (!cancelled && isForceUpdate(res)) setBlocked(true); })
      .catch(() => { /* ignore — never block on error */ });
    // Connectivity/health ping (Login/Status returns a health string, not a
    // session validator; there is no session-validation endpoint in the API).
    authApi.status().catch(() => { /* ignore */ });
    return () => { cancelled = true; };
  }, []);

  if (blocked) return <BlockScreen />;
  return children;
};

export default AppBootGate;
